import React, { useState } from "react";
import * as Yup from "yup";
import {
    useCreateMerchantMutation,
    useLoginApiMutation,
} from "../../redux/api/authApi/authApi";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import loginLine from "../../assets/images/loginLine.png";
import logo from "../../assets/images/tasnuva_courier.png";
import CustomInput from "../../components/CustomInput";
import CustomLoading from "../../components/CustomLoading";
import CustomModal from "../../components/CustomModal";
import { useGetBranchListQuery } from "../../redux/api/branchApi/branchApi";
import { useUpdateMerchantMutation } from "../../redux/api/merchantApi/merchantApi";

const Login = () => {
    const [loginMerchant, result] = useLoginApiMutation();
    const [createMerchant, createResult] = useCreateMerchantMutation();
    const [updateMerchant, updateResult] = useUpdateMerchantMutation();
    const { data: branchList, isLoading: branchLoading } =
        useGetBranchListQuery(undefined);
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    const validationSchema1 = Yup.object().shape({
        email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),
        password: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .required("Password is required"),
    });

    const initialValues1 = {
        email: "",
        password: "",
    };

    const formik1 = useFormik({
        initialValues: initialValues1,
        validationSchema: validationSchema1,
        onSubmit: async (values) => {
            try {
                await loginMerchant(values).unwrap();
                toast.success("Successfully logged in!");
                navigate("/");
            } catch (error) {
                console.log(error);
                toast.error(error?.data?.message || "Something went wrong!");
            }
        },
    });

    const validationSchema2 = Yup.object().shape({
        merchantname: Yup.string().required("Merchant name is required"),
        companyname: Yup.string().required("Company name is required"),
        email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),
        phone: Yup.string().required("Phone number is required"),
        address: Yup.string().required("Address is required"),
        branch: Yup.string().required("Branch is required"),
        password: Yup.string()
            .min(6, "At least 6 characters")
            .required("Password is required"),
    });

    const initialValues2 = {
        merchantname: "",
        companyname: "",
        email: "",
        phone: "",
        address: "",
        branch: "",
        password: "",
    };

    const formik2 = useFormik({
        initialValues: initialValues2,
        validationSchema: validationSchema2,
        onSubmit: async (values) => {
            const data = {
                name: values.merchantname,
                email: values.email,
                password: values.password,
                password_confirm: values.password,
                company_name: values.companyname,
                address: values.address,
                contact_number: values.phone,
                branch_id: values.branch,
            };
            try {
                const createdResult = await createMerchant(data).unwrap();
                await updateMerchant({ merchantId: createdResult?.id, data: { permissions: ["ShowDashboard", "StoreList", "CreateStore", "UpdateStore", "RemoveStore", "PickupRequest", "CreateParcel", "UpdateParcel", "ListParcel", "ExportParcelList", "WalletInformation", "PaymentRerquest", "InvoiceList", "DownloadInvoiceList", "OrderTracking", "CreateOperator", "EditOperator", "DeleteOperator"] } }).unwrap();
                formik1.setFieldValue('email', values.email);
                formik1.setFieldValue('password', values.password);
                toast.success("Successfully created merchant!");
                setShowModal(false);
            } catch (error) {
                console.log(error);
                toast.error(error?.data?.message || "Something went wrong!");
            }
        },
    });

    return (
        <div className="flex flex-row w-full h-[100vh] justify-center items-center">
            <div className="h-auto flex flex-row shadow rounded-r-2xl overflow-hidden">
                <div
                    data-aos="fade-right"
                    className="py-14 px-10 flex-col gap-4 justify-center items-center relative bg-primary md:flex hidden"
                >
                    <div>
                        <img
                            alt="login"
                            src="https://res.cloudinary.com/di23omfvx/image/upload/v1692419215/login_lzs3ti.gif"
                            className="w-[300px]"
                        />
                    </div>
                    <div>
                        <div className="text-center text-white text-xl">
                            Connecting to all Services
                        </div>
                        <div className="text-center !text-[#f4f4f4] text-sm">
                            Safe and swift delivery of the items.
                        </div>
                        <div className="absolute bottom-0 left-0">
                            <img alt="login" src={loginLine} className="h-36 w-36" />
                        </div>
                    </div>
                </div>
                <div
                    data-aos="fade-left"
                    className="py-14 px-10 flex flex-col justify-center items-center bg-white"
                >
                    <div className="text-center flex flex-col gap-3 items-center">
                        <img alt="login" src={logo} className="w-[250px]" />
                        <div className="text-2xl text-text_1 font-bold">
                            Log In to Merchant Panel
                        </div>
                        <div className="text-text_2">
                            Enter your email address and password below
                        </div>
                    </div>
                    <form
                        onSubmit={formik1.handleSubmit}
                        className="w-full flex flex-col gap-2 mt-5"
                    >
                        <CustomInput
                            label="EMAIL"
                            type="email"
                            setFieldValue={formik1.setFieldValue}
                            value={formik1.values.email}
                            touched={formik1.touched.email}
                            error={formik1.errors.email}
                            handleBlur={formik1.handleBlur}
                        />
                        <CustomInput
                            label="PASSWORD"
                            type="password"
                            setFieldValue={formik1.setFieldValue}
                            value={formik1.values.password}
                            touched={formik1.touched.password}
                            error={formik1.errors.password}
                            handleBlur={formik1.handleBlur}
                        />
                        <button
                            type="submit"
                            className="w-full text-white text-center py-3 rounded-xl text-xl bg-text_1 shadow mt-5 cursor-pointer hover:animate-pulse transition-all"
                        >
                            Log In
                        </button>
                        <button
                            onClick={() => setShowModal(true)}
                            type="button"
                            className="w-full text-white text-center py-3 rounded-xl text-xl bg-primary shadow mt-2 cursor-pointer hover:animate-pulse transition-all"
                        >
                            Create An Account
                        </button>
                    </form>
                </div>
            </div>
            <CustomModal
                showModal={showModal}
                setShowModal={setShowModal}
                submitButton={true}
                handleSubmit={formik2.handleSubmit}
                title={"Create New Merchant Account"}
            >
                <form
                    onSubmit={formik2.handleSubmit}
                    className="w-full flex flex-col gap-2 mt-5 min-w-[70%]"
                >
                    <div className="flex flex-col sm:flex-row gap-5">
                        <CustomInput
                            label="MERCHANT NAME"
                            type="text"
                            setFieldValue={formik2.setFieldValue}
                            value={formik2.values.merchantname}
                            touched={formik2.touched.merchantname}
                            error={formik2.errors.merchantname}
                            handleBlur={formik2.handleBlur}
                        />
                        <CustomInput
                            label="COMPANY NAME"
                            type="text"
                            setFieldValue={formik2.setFieldValue}
                            value={formik2.values.companyname}
                            touched={formik2.touched.companyname}
                            error={formik2.errors.companyname}
                            handleBlur={formik2.handleBlur}
                        />
                    </div>
                    <div className="flex flex-col sm:flex-row gap-5">
                        <CustomInput
                            label="EMAIL"
                            type="email"
                            setFieldValue={formik2.setFieldValue}
                            value={formik2.values.email}
                            touched={formik2.touched.email}
                            error={formik2.errors.email}
                            handleBlur={formik2.handleBlur}
                        />
                        <CustomInput
                            label="PHONE"
                            type="number"
                            setFieldValue={formik2.setFieldValue}
                            value={formik2.values.phone}
                            touched={formik2.touched.phone}
                            error={formik2.errors.phone}
                            handleBlur={formik2.handleBlur}
                        />
                    </div>
                    <div className="flex flex-col sm:flex-row gap-5">
                        <div className="w-full my-2">
                            <div className="text-text_2 text-md font-semibold mb-2">
                                SELECT BRANCH
                            </div>
                            <select
                                id="branch"
                                onBlur={formik2.handleBlur}
                                value={formik2.values.branch}
                                onChange={(e) =>
                                    formik2.setFieldValue("branch", e.target.value)
                                }
                                className="w-full border-2 p-2 rounded-lg focus:outline-none focus:border-secondary"
                            >
                                <option value="">Select a branch</option>
                                {branchList?.map((data, index) => {
                                    return (
                                        <option key={index} value={data?.id}>
                                            {data?.name}
                                        </option>
                                    );
                                })}
                            </select>
                            {formik2.touched.branch && formik2.errors.branch ? (
                                <span className="text-error text-sm mt-1">
                                    {formik2.errors.branch}
                                </span>
                            ) : null}
                        </div>
                        <CustomInput
                            label="PASSWORD"
                            type="password"
                            setFieldValue={formik2.setFieldValue}
                            value={formik2.values.password}
                            touched={formik2.touched.password}
                            error={formik2.errors.password}
                            handleBlur={formik2.handleBlur}
                        />
                    </div>
                    <div className="flex flex-col sm:flex-row gap-5">
                        <div className="w-full my-2">
                            <label className="font-semibold text-text_2">
                                Merchant Address
                            </label>
                            <br />
                            <div className="relative flex items-center rounded-lg w-full mt-2">
                                <textarea
                                    className="flex-grow border-2 p-2 rounded-lg w-full focus:border-secondary focus:outline-none"
                                    placeholder={`Enter your address`}
                                    onChange={(e) =>
                                        formik2.setFieldValue("address", e.target.value)
                                    }
                                    value={formik2.values.address}
                                    onBlur={formik2.handleBlur}
                                    name="address"
                                    rows={3}
                                />
                            </div>
                            {formik2.touched.address && formik2.errors.address ? (
                                <span className="text-error text-sm mt-1">
                                    {formik2.errors.address}
                                </span>
                            ) : null}
                        </div>
                    </div>
                </form>
            </CustomModal>
            {(result?.isLoading || branchLoading || createResult?.isLoading || updateResult?.isLoading) && <CustomLoading />}
        </div>
    );
};

export default Login;
